import React from 'react';
import _ from 'lodash';

import { Icon, Stack, TooltipHost } from '@fluentui/react';

import { DataEnchanter } from '../../../../utils/data-enchanters';
import { useTranslation } from 'react-i18next';
import { ApplicationSettings } from '../../../../utils/application'
import { useClassNames } from './iai-solved-status-column.classNames';
import { TicketSolvedStatusEnum, TicketStatusEnum } from '../../../../api-client';
import statusHelper from '../../../../utils/helpers/statusHelper';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../redux/application/redux-store';

interface IIAISolvedStatusColumn {
    align: 'start' | 'center' | 'end';
    solvedInDays?: number;
    ticketStatus?: TicketStatusEnum;
    departmentId?: string;
}

const IAISolvedStatusColumn: React.FunctionComponent<IIAISolvedStatusColumn> = ({
    align = 'start',
    solvedInDays,
    ticketStatus,
    departmentId
}) => {
    const departments = useSelector((state: RootState) => state.system.departments);

    const status = !ticketStatus || ticketStatus !== TicketStatusEnum.Closed ? TicketSolvedStatusEnum.Inprogress : statusHelper.getSolvedStatus(solvedInDays, departments.find(x => x.id === departmentId)?.resolutionDays);

    const {
        statusIcon
    } = useClassNames({ status });

    const {
        t: translate
    } = useTranslation();

    if (ticketStatus === TicketStatusEnum.Canceled || ticketStatus === TicketStatusEnum.Deleted) {
        return null;
    }

    return (
        <div className={`text-${align}`}>
            <TooltipHost
                hidden={ApplicationSettings.IAI_APP_DISABLE_COLORBLIND}
                content={(
                    <Stack>
                        {_.map(DataEnchanter.colorblindBySolvedStatusEnum(status || ''), (dataItem, dataIndex) => (
                            <Stack key={dataIndex} horizontal verticalAlign="center">
                                <Icon
                                    iconName={'StatusCircleInner'}
                                    className={statusIcon}
                                    styles={{ root: { color: dataItem } }}
                                />
                                {translate(DataEnchanter.textBySolvedStatusEnum(status || ''))}
                            </Stack>
                        ))}
                    </Stack>
                )}
            >
                <Stack horizontal verticalAlign="center">
                    <Icon iconName={statusHelper.getSolvedStatusIcon(status)} className={statusIcon} />
                    {translate(DataEnchanter.textBySolvedStatusEnum(status))}
                </Stack>
            </TooltipHost>
        </div>
    );
}

export default IAISolvedStatusColumn;